var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "c-card",
        { staticClass: "cardClassDetailForm", attrs: { title: "기본정보" } },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-appr-btn", {
                    ref: "appr-btn",
                    attrs: {
                      name: "danger-journal-appr-btn",
                      editable: _vm.editable,
                      approvalInfo: _vm.approvalInfo,
                    },
                    on: {
                      beforeApprAction: _vm.saveDataAppr,
                      callbackApprAction: _vm.approvalCallback,
                      requestAfterAction: _vm.getDetail,
                    },
                  }),
                  _vm.editable && !_vm.disabled && _vm.isRemove
                    ? _c("c-btn", {
                        attrs: {
                          label: "삭제",
                          editable: _vm.editable,
                          icon: "delete_forever",
                        },
                        on: { btnClicked: _vm.removeData },
                      })
                    : _vm._e(),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          url: _vm.saveUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.data,
                          mappingType: _vm.saveType,
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveJournal,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    required: "",
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    label: "취급일지명",
                    name: "envDangerTitle",
                  },
                  model: {
                    value: _vm.data.envDangerTitle,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "envDangerTitle", $$v)
                    },
                    expression: "data.envDangerTitle",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    required: "",
                    readonly: true,
                    editable: _vm.editable,
                    label: "품명(위험물저장소)",
                    name: "envDangerMstName",
                    afterIcon:
                      _vm.disabled || _vm.updateMode
                        ? null
                        : [
                            {
                              name: "search",
                              click: true,
                              callbackName: "searchDangerMaster",
                            },
                            {
                              name: "close",
                              click: true,
                              callbackName: "removeDangerMaster",
                            },
                          ],
                  },
                  on: {
                    searchDangerMaster: _vm.searchDangerMaster,
                    removeDangerMaster: _vm.removeDangerMaster,
                  },
                  model: {
                    value: _vm.data.envDangerMstName,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "envDangerMstName", $$v)
                    },
                    expression: "data.envDangerMstName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    required: "",
                    range: true,
                    name: "period",
                    disabled: _vm.disabled || _vm.updateMode,
                    defaultStart: "0d",
                    defaultEnd: "6d",
                    label: "기간",
                  },
                  on: { datachange: _vm.gridchange },
                  model: {
                    value: _vm.period,
                    callback: function ($$v) {
                      _vm.period = $$v
                    },
                    expression: "period",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: {
                    required: "",
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    type: "edit",
                    name: "plantCd",
                  },
                  model: {
                    value: _vm.data.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "plantCd", $$v)
                    },
                    expression: "data.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: true,
                    editable: _vm.editable,
                    label: "설치장소",
                    name: "envDangerArea",
                  },
                  model: {
                    value: _vm.data.envDangerArea,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "envDangerArea", $$v)
                    },
                    expression: "data.envDangerArea",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    label: "지정수량",
                    name: "envDangerCount",
                  },
                  model: {
                    value: _vm.data.envDangerCount,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "envDangerCount", $$v)
                    },
                    expression: "data.envDangerCount",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    label: "주용도",
                    name: "envDangerMainUse",
                  },
                  model: {
                    value: _vm.data.envDangerMainUse,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "envDangerMainUse", $$v)
                    },
                    expression: "data.envDangerMainUse",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-multi-field", {
                  attrs: {
                    editable: _vm.editable,
                    data: _vm.data,
                    disabled: _vm.disabled,
                    label: "안전관리자",
                    type: "user",
                    name: "envDangerManageUserId",
                  },
                  model: {
                    value: _vm.data.envDangerManageUserId,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "envDangerManageUserId", $$v)
                    },
                    expression: "data.envDangerManageUserId",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-multi-field", {
                  attrs: {
                    editable: _vm.editable,
                    data: _vm.data,
                    disabled: _vm.disabled,
                    label: "담당자",
                    type: "user",
                    name: "envDangerUserId",
                  },
                  model: {
                    value: _vm.data.envDangerUserId,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "envDangerUserId", $$v)
                    },
                    expression: "data.envDangerUserId",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-multi-field", {
                  attrs: {
                    editable: _vm.editable,
                    data: _vm.data,
                    disabled: _vm.disabled,
                    label: "안전대리자",
                    type: "user",
                    name: "envDangerSafetyUserId",
                  },
                  model: {
                    value: _vm.data.envDangerSafetyUserId,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "envDangerSafetyUserId", $$v)
                    },
                    expression: "data.envDangerSafetyUserId",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c("c-tab", {
            attrs: {
              type: "tabcard",
              tabItems: _vm.tabItems,
              inlineLabel: true,
              align: "left",
            },
            on: {
              "update:tabItems": function ($event) {
                _vm.tabItems = $event
              },
              "update:tab-items": function ($event) {
                _vm.tabItems = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (tab) {
                  return [
                    _c(tab.component, {
                      tag: "component",
                      attrs: {
                        data: _vm.data,
                        itemGrid: _vm.itemGrid,
                        prevList: _vm.prevList,
                        resultGrid: _vm.resultGrid,
                        contentHeight: _vm.contentHeight,
                      },
                      on: {
                        "update:itemGrid": function ($event) {
                          _vm.itemGrid = $event
                        },
                        "update:item-grid": function ($event) {
                          _vm.itemGrid = $event
                        },
                        "update:prevList": function ($event) {
                          _vm.prevList = $event
                        },
                        "update:prev-list": function ($event) {
                          _vm.prevList = $event
                        },
                        "update:resultGrid": function ($event) {
                          _vm.resultGrid = $event
                        },
                        "update:result-grid": function ($event) {
                          _vm.resultGrid = $event
                        },
                        getDetail: _vm.getDetail,
                      },
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }